.wrap {
  padding-block: clamp(60px, 10vw, 120px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
}

.title {
  font-size: clamp(34px, 5vw, 48px);
  line-height: 1.1;
  color: var(--ink);
}

.body {
  font-size: 17px;
  line-height: 1.6;
  color: var(--ink-muted);
}

.link {
  margin-top: 8px;
  padding: 12px 24px;
  border-radius: 14px;
  background: var(--ink);
  color: var(--on-ink);
  min-height: 44px;
  display: flex;
  align-items: center;
}

.link:hover {
  background: #403b32;
  color: var(--on-ink);
}
